const ModelLocalizer = require('./model-localizer');

const OFFER_L10N_MAP = [['headline', 'headlineLocalized'], ['subHeadline', 'subHeadlineLocalized'], ['details', 'detailsLocalized'], ['legal', 'legalLocalized', true] // optional
];

module.exports = locales => new ModelLocalizer({
  locales,
  fieldMapping: OFFER_L10N_MAP
});